import React, { useContext, useEffect,useState } from "react";
import { useNavigate,Link,Outlet} from "react-router-dom";
import { CustomerContext } from "./CustomerContext";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTachometerAlt,faSignOut, faUser} from '@fortawesome/free-solid-svg-icons';
import "./customerDashboard.css"
export default function CustomerDashboard(){
  const [dropdownVisible,setDropdownVisible]=useState(false)
  // const styles=`

  // @media(min-width:01px) and (max-width:1200px){
  // .landing-page{
  //    font-size: 1.125rem ;
  //     line-height: 1.75rem 
  // }
  // }
  // @media(min-width:601px) and (max-width:900px){
  // .landing-page{
  //     font-size: 1rem ;
  //       line-height: 1.5rem ;
  // }
  // }
  
  // @media(min-width:401px) and (max-width:600px){
  // .landing-page{
  //   font-size: 0.875rem ;
  //       line-height: 1.25rem;
  // }
  // }
  
  // @media(min-width:0px) and (max-width:400px){
  // .landing-page{
  //        font-size: 0.75rem;
  //       line-height: 1rem ;
  // }
  // }
  // `
  // const styleSheet=document.createElement("style")
  // styleSheet.type="text/css";
  // styleSheet.innerText=styles
  // document.head.appendChild(styleSheet)
  const {customerData}=useContext(CustomerContext) 
  const navigate=useNavigate()
    return (
      <div className="bg-gray-100 flex flex-col  landing-page max-w-full min-w-fit mt-20">
       <div className="relative"
                    onMouseEnter={() => setDropdownVisible(true)}
                    onMouseLeave={() => setDropdownVisible(false)}>
            <Link className=" hover:text-blue-500 flex flex-col"  to="account">
              {customerData?.profile ? <img src={customerData?.profile} alt="Profile" className=" h-20 w-20 rounded-full"/>:
              <FontAwesomeIcon icon={faUser} className=" w-12 h-12 rounded-full"     />}
            </Link>
           
            {dropdownVisible && 
               <div className="top-20 left-0 bg-white shadow-lg rounded-md p-4 w-40  gap-x-6  max-w-40 min-w-fit">
                 <Link to="/customerDash/account/change" className="block text-gray-700 hover:text-blue-500 mb-2">
                    <FontAwesomeIcon icon={faTachometerAlt}/>Account
                 </Link>

                 <Link to="/customerDash/account/logout" className="block text-gray-700 hover:text-blue-500 mb-2">
                    <FontAwesomeIcon icon={faSignOut}/>Logout
                 </Link>
               </div>
            }

            </div>
        
      <p className="text-blue-500 italic">Welcome {customerData?.username}</p>
      <h4 className="text-lg font-semibold mb-4">BANKS</h4>
      <div className=" space-x-2 max-w-full min-w-fit landing-page flex flex-row flex-grow-0">
         <Link to="hotels" className="hover:text-blue-500">Hotels</Link>
         <Link to="banks" className="hover:text-blue-500">Banks</Link>
         <Link to="farmers" className="hover:text-blue-500">Farmers</Link>
         <Link to="transporters" className="hover:text-blue-500">Transporters</Link>
         <Link to="communicate" className="hover:text-blue-500">Communicate</Link>
      </div>
      <Outlet/>
      
     
  </div>
)
      
}
